import { useState, useEffect, useCallback } from "react";

const useEnum = (api) => {
    const [ data, setData ] = useState([]);
    const [ loading, setLoading ] = useState(false);
    const [ error, setError ] = useState(null);

    const fetchData = useCallback(() => {
        setLoading(true);

        api()
            .then(res => setData(res.data.map(r => ({ label : r.descricao, value : r.id }) )))
            .catch(err => setError(err))
            .finally(() => setLoading(false));
    }, [api]);

    useEffect(() => fetchData(), [fetchData]);

    return { data, loading, error };
}

export default useEnum;